module.exports = __webpack_public_path__ + "img/board.3a8c2a92.png";